import * as Yup from 'yup'
import { parseCoordinates, toMicroDegrees } from 'utils/utils'

export const INITIAL_VALUES = {
  contractorId: null,
  startLocation: {
    text: ''
  },
  endLocation: {
    text: ''
  },
  price: '',
  currencyCode: 'PLN',
  bunkerAdjustmentFactor: '0',
  additionalInfo: '',
  harbourLocation: '0.000000, 0.000000',
  type: ''
}

const createLocationSchema = () => Yup.object().shape({
  text: Yup.string().required()
})

export const createValidationSchema = () => {
  return Yup.object().shape({
    contractorId: Yup.string()
      .nullable()
      .required(),
    startLocation: createLocationSchema(),
    endLocation: createLocationSchema(),
    price: Yup.number()
      .min(0)
      .max(1000000000)
      .required(),
    currencyCode: Yup.string()
      .matches('^[A-Z]{3}$', 'form.validation.currencyCode')
      .required(),
    bunkerAdjustmentFactor: Yup.number()
      .min(0)
      .max(100)
      .required(),
    additionalInfo: Yup.string(),
    harbourLocation: Yup.string().required()
      .test('coordinates', 'form.validation.coordinates', text => {
        if (text) {
          const coordinates = parseCoordinates(text)
          return coordinates != null
        }
        return true
      }),
    type: Yup.string().required()
  })
}

export function toFerryValues (ferryService) {
  const {
    contractorId,
    startLocation,
    endLocation,
    price,
    currencyCode,
    bunkerAdjustmentFactor,
    additionalInfo,
    harbourLocation,
    type
  } = ferryService
  return ({
    contractorId,
    startLocation,
    endLocation,
    price,
    currencyCode,
    bunkerAdjustmentFactor,
    additionalInfo,
    harbourLocation: harbourLocation.text,
    type
  })
}

export function toRequestParams (ferryService) {
  const [lat, lng] = parseCoordinates(ferryService.harbourLocation)

  return ({
    ...ferryService,
    harbourLocation: {
      latitudeMicroDegrees: toMicroDegrees(lat),
      longitudeMicroDegrees: toMicroDegrees(lng)
    }
  })
}


